import { nostojs } from "./api"

export default function () {
  nostojs(api => {
    api.listen("postrender", () => {
      const settings = api.internal.getSettings()
      const { convertAll, currentCurrency } = window.Currency || {}
      if (convertAll && currentCurrency) {
        try {
          convertAll(settings.defaultCurrencyCode, currentCurrency)
        } catch (e) {
          const message = e instanceof Error ? e.message : String(e)
          console.warn(`Exception on calling currency.convertAll():${message}`)
        }
      }
    })
  })
}
